export default "__VITE_ASSET__05cK6b88__"